import { idClienteSelector } from "common/_redux/company/selectors";
import { praticaIdPraticaSelector } from "common/_redux/pratica/selectors";
import { subjectGetDetails } from "common/_redux/subject/actions";
import { legaleRappresentanteSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import { goToTop } from "common/helpers/common-utils";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import { Subject } from "models/subject";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Anagrafica from "../_common-components/anagrafica";
import CarichePubbliche from "../_common-components/cariche-pubbliche";

const title = "3. Dati legale rappresentante";
const subtitle =
	"Completa le informazioni richieste e controlla che quelle già inserite siano corrette.";

const IdentificazioneLegaleRappresentante: React.FC = () => {
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const idPratica = useAppSelector(praticaIdPraticaSelector);
	const idCliente = useAppSelector(idClienteSelector);
	const legaleRappresentanteDetails = useAppSelector<Subject | any>(legaleRappresentanteSelector);

	const activeAccordionIndex =
		(steps
			?.find((s) => s.route == AppRouterService.get(PathEnum.step3))
			?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0) + 1;

	const goNext = (route: string) => {
		navigate(route);
	};

	const goBack = () => {
		navigate(-1);
	};

	useEffect(() => {
		if (location.pathname == AppRouterService.get(PathEnum.identificazioneLegaleRappresentante))
			navigate(AppRouterService.get(PathEnum.anagraficaLR));
	}, []);

	useEffect(() => {
		setTimeout(() => {
			const id = activeAccordionIndex > 1 ? `accordion-${activeAccordionIndex}` : null;
			goToTop(id);
		}, 300);
	}, [activeAccordionIndex]);

	useEffect(() => {
		dispatch(subjectGetDetails());
	}, []);

	return (
		<>
			<h2 className="mb-3 ms-3">{title}</h2>
			<span className="gray">{subtitle}</span>

			{/* Anagrafica */}
			<BftAccordion
				title="Anagrafica"
				index={1}
				total={2}
				isActive={location.pathname === AppRouterService.get(PathEnum.anagraficaLR)}
				isCompleted={activeAccordionIndex > 1}
			>
				<Anagrafica
					subjectDetails={legaleRappresentanteDetails}
					idCliente={idCliente}
					idPratica={idPratica}
					onComplete={() => goNext(AppRouterService.get(PathEnum.ulterioriInformazioniLR))}
				/>
			</BftAccordion>

			{/* Cariche pubbliche - Ulteriori Informazioni */}
			<BftAccordion
				title="Ulteriori Informazioni"
				index={2}
				total={2}
				isActive={location.pathname === AppRouterService.get(PathEnum.ulterioriInformazioniLR)}
				isCompleted={activeAccordionIndex > 2}
				disabled={activeAccordionIndex < 4}
			>
				<CarichePubbliche
					subjectDetails={legaleRappresentanteDetails}
					idCliente={idCliente}
					idPratica={idPratica}
					onComplete={() => goNext(AppRouterService.get(PathEnum.completeLR))}
				/>
			</BftAccordion>

			<Row className="justify-content-between mx-3">
				<Col xs={1} className="p-0">
					<BftButton className="btn-buffetti-secondary ms-0 px-3" onClick={() => goBack()}>
						<i className="fas fa-arrow-left"></i>
					</BftButton>
				</Col>

				<Col xs={10} md={11} className="pe-0">
					<BftButton
						className="btn-buffetti col-12"
						isDisabled={activeAccordionIndex <= 3}
						onClick={() => goNext(AppRouterService.get(PathEnum.sceltaTitolareEffettivo))}
					>
						Vai allo step successivo
					</BftButton>
				</Col>
			</Row>
		</>
	);
};

export default IdentificazioneLegaleRappresentante;
